module.exports = __webpack_public_path__ + "img/idoom.d04497be.svg";